// ID_ENTRY — Section 10. Shown every time the app is opened. Not validated
// against a server list; the researcher assigns IDs before handing out
// devices. Last-used ID is pre-filled (spec Section 19, caveat #7) to cut
// down on typos/ID confusion.

import { useState } from 'react';
import { useParticipantStore } from '../store/participantStore';
import ConfirmationModal from '../components/ConfirmationModal';

export default function IDEntryScreen({ onDone }) {
  const lastId = useParticipantStore((s) => s.participant_id);
  const setParticipantId = useParticipantStore((s) => s.setParticipantId);
  const [value, setValue] = useState(lastId ?? '');
  const [confirming, setConfirming] = useState(false);

  const canContinue = value.trim().length > 0;

  return (
    <div className="screen justify-center">
      <div className="text-center mb-10">
        <h1 className="font-display text-4xl tracking-tight">ASPIRE</h1>
        <p className="text-dim mt-2">Speech &amp; memory study</p>
      </div>

      <label htmlFor="participant-id" className="text-sm text-dim mb-2">
        Participant ID
      </label>
      <input
        id="participant-id"
        type="text"
        inputMode="text"
        autoCapitalize="characters"
        autoCorrect="off"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="e.g. P001"
        className="min-h-touch rounded-xl2 bg-panel border border-hairline px-4 text-lg mb-6
          focus:border-amber outline-none"
      />

      <button type="button" disabled={!canContinue} onClick={() => setConfirming(true)} className="btn-primary">
        Continue
      </button>

      <ConfirmationModal
        open={confirming}
        title="Is this correct?"
        message={`You entered "${value.trim()}"`}
        confirmLabel="Yes, that's correct"
        cancelLabel="No, let me fix it"
        onCancel={() => setConfirming(false)}
        onConfirm={async () => {
          await setParticipantId(value.trim());
          setConfirming(false);
          onDone();
        }}
      />
    </div>
  );
}
